// @flow
import React from 'react'
import { Link } from 'react-router'
import Helmet from 'react-helmet'
import PageHeader from '../../components/PageHeader'
import FaqTabs from '../../components/FaqTabs'
import Card from '../../components/Card'

const BuyingWithUs = () => (
  <div>
    <Helmet title="Buy a Home with Us" />
    <PageHeader text="Buying a Home with Kief Realty">
      Let&apos;s get the best value on the home you really want.
      <br />
      <br />
      Kief Realty is a full-service brokerage licensed in the State of Illinois.
      Our team is committed to your happiness, providing you with honest advice,
      helping you find the right home, and negotiating the best value for you.
    </PageHeader>
    <FaqTabs />
    <div className="container">
      <h1 style={{ textAlign: 'center', marginBottom: '1rem' }}>
        The Kief Realty Process
      </h1>
      <Card style={{ margin: '2rem auto', maxWidth: '700px' }}>
        <h2>Finding your home</h2>
        <p>
          We believe that buyers should be able to search on any website or app
          to find the home they really want, no matter what listing agency is
          marketing the home. When you buy with us, you won&apos;t be limited in
          your options. We take the listings you&apos;re interested in, and our
          team works with you throughout the entire home buying process.
        </p>
        <strong>How does Kief Realty help me find a home?</strong>
        <p>
          Kief Realty team members are experts not only in what to look for, but
          also where to find them. We use a mix of old and new techniques to
          make sure we get a full view of all options that suit your
          preferences.
        </p>
        <p>
          Kief Realty experts monitor the market for available homes using tech
          tools developed in-house. These tools ensure that we see each
          available home.
        </p>
        <p>
          We send our clients alerts personalized to their preferences. We send
          you a filtered list of properties tailored to you, making your house
          hunting journey as convenient as possible.
        </p>
        <strong>
          Do Kief Realty team members really come with me for house tours?
        </strong>
        <p>
          Yes, absolutely. Kief Realty&apos;s team is seasoned and trained to
          give you expert advice right inside the home you&apos;re interested
          in. If you&apos;re unable to tour a house in person, we can offer to
          give you a virtual video tour of the home.
        </p>
        <p>
          For first-time Kief Realty clients, we may verify your identity or
          require an initial office meeting as a security measure, so please
          plan ahead. We will let you know about this beforehand. We do reserve
          the right to decline certain tour requests.
        </p>
        <strong>I have a financing question, can you help me?</strong>
        <p>
          Yes. Kief Realty&apos;s team is educated on preliminary loan
          qualifications and various financing options. We also have established
          relationships with many loan officers in our various market areas.
        </p>
        <p>
          We may be able to answer some of your initial questions, but
          ultimately we can provide you contact information of many excellent
          loan officers for you to work with. We don&apos;t have exclusive
          relationships with lenders, so based on your needs and qualifications,
          we will help you evaluate your options and recommend what we feel
          might be the best fit.
        </p>
      </Card>
      <Card style={{ margin: '2rem auto', maxWidth: '700px' }}>
        <h2>Making your offer</h2>
        <p>
          Once we&apos;ve found your ideal home, it&apos;s now time to make an
          offer. With Kief Realty, initiating an offer can be done online. From
          there, a Kief Realty team member will be in touch to gather additional
          information, answer any questions you have and complete your offer
          packet to be submitted to the listing agent or seller on your behalf.
        </p>
        <p>
          This will start the negotiation process and hopefully result in an
          agreed upon home purchase contract.
        </p>
        <strong>How much should I offer?</strong>
        <p>
          When making an offer, you primarily want to consider the value of
          other similar homes in the area, and how the home you are pursuing
          compares and differs to those other homes. Other factors that might
          influence your offer decision could be the home&apos;s square footage,
          how long it has been on the market and your overall level of interest
          and desire to purchase the home. A Kief Realty expert will always be
          there to assist you with market values and area statistics. Our team
          wants to ensure that you get the best value and do not overpay.
        </p>
      </Card>
      <Card style={{ margin: '2rem auto', maxWidth: '700px' }}>
        <h2>Closing your home purchase</h2>
        <p>
          When your offer is accepted, we will take care of all the details from
          that point forward and make sure that you are kept up to date with the
          progress. If there is anything that you personally need to be doing or
          coordinating, we will be there to advise you.
        </p>
        <p>
          For first time buyers, these guides provide a good overview of what to
          expect:
        </p>
        <div>
          <a href="http://www.zillow.com/home-buying-guide/real-estate-closing/">
            Zillow Buyer&apos;s Guide
          </a>
          <span> - Closing on a House for the Buyer</span>
        </div>
        <div>
          <a href="http://www.realtor.com/advice/navigating-the-closing-process-for-home-buyers/">
            Realtor.com
          </a>
          <span>
            {' '}
            The Closing Process: What Home Buyers and Sellers Can Expect
          </span>
        </div>
        <br />
        <strong>How about home inspections?</strong>
        <p>
          In some instances, home sellers will have a certified and licensed
          home inspector perform an inspection before or when they list their
          home. If this is the case, the inspection report will be made
          available to you for your review. If not, then you will have your own
          opportunity to hire a licensed home inspector. The purpose of your
          inspection would primarily be to confirm that major structural and
          mechanical components of the home are in proper working order and
          acceptable condition. If you find that something doesn&apos;t meet
          your expectation, you will have the opportunity to address it with the
          seller.
        </p>
        <p>
          Kief Realty has established relationships with reputable licensed home
          inspectors, and can provide you a contact list upon request.
        </p>
        <strong>How much does it cost me when I buy with Kief Realty?</strong>
        <p>
          One million dollars. Just kidding, it really costs you NOTHING. Zero,
          zip, zilch, nada. Kief Realty will still be compensated, just not by
          you. The seller typically covers the commission costs. This is
          explained in more detail on our rebate page.
        </p>
        <p>
          This can still be true even if you&apos;re purchasing a home that is
          For Sale By Owner. If the seller is open and willing to compensate
          Kief Realty a predetermined and agreed upon commission, then you can
          move forward just as if you were buying any other home on the market.
          We are paid by the seller, but only have an agency relationship with
          you.
        </p>
        <Link to="/rebate">Learn more about our rebate</Link>
      </Card>
    </div>
  </div>
)

export default BuyingWithUs



// WEBPACK FOOTER //
// ./src/views/BuyingWithUs/index.js